export function convertTermsToHtml(raw) {
  const bolded = raw.replace(/\*([^*\n]+?)\*/g, "<strong>$1</strong>");
  const html = bolded.replace(/\r?\n/g, "<br/>");
  return html;
}

export function formatText1(text) {
  if (!text) return "";
  let formatted = text
    .replace(/\n/g, "<br/>") // Convert line breaks to <br/>
    .replace(/  /g, "&nbsp;&nbsp;"); // Preserve double spaces

  return formatted;
}
